export default __webpack_public_path__ + "static/media/car_accident_icon.b850482b.png";